<template>
  <a-tabs defaultActiveKey="1">
    <a-tab-pane tab="DISFRUTE DE VACACIONES" key="1">
      <g-master :name="master.endpoint"
                @params="paramsTable"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :actions="false"
      >
        <template slot="customButton">
          <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
        </template>
        <template slot="expandedRowRender" slot-scope="{text}">
          <template v-for="ve in master.valoresExpandidos">
            {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
          </template>
        </template>
      </g-master>
    </a-tab-pane>
    <a-tab-pane tab="PROGRAMACIÓN DE VACACIONES" key="2">
      <prog-vac></prog-vac>
    </a-tab-pane>
  </a-tabs>
</template>
<script>
  import JsUtils from '../../../../../util/JsUtils'

  export default {
    data () {
      return {
        master: {
          valoresExpandidos: [
            {label: 'ID concepto', column: 'id_coc'},
            {label: 'Documento', column: 'htv_doc'},
            {label: 'Día siguiente del mes', column: 'htv_daynextmonth'},
            {label: 'Comentario', column: 'htv_obs'},
            {label: 'Compensado en dinero', column: 'htv_completed'}
          ],
          endpoint: 'dist_vac_consulta',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            actions: false,
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'ID del empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre completo', dataIndex: 'view_attr', sorter: true},
              {title: 'Fecha inicial periodo', dataIndex: 'htv_ini_desc', sorter: true},
              {title: 'Fecha final periodo', dataIndex: 'htv_end_desc', sorter: true},
              {title: 'Fecha inicio del disfrute', dataIndex: 'htv_since_desc', sorter: true},
              {title: 'Fecha fin del disfrute', dataIndex: 'htv_to_desc', sorter: true},
              {title: 'Tiempo del disfrute', dataIndex: 'htv_time', sorter: true},
              {title: 'Compensado en dinero', dataIndex: 'htv_comp', sorter: true},
              {title: 'Fecha de pago', dataIndex: 'payment_date_desc', sorter: true},
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Mes', dataIndex: 'mes', sorter: true},
              {title: 'Período', dataIndex: 'period', sorter: true},
              {title: 'Días no hábil', dataIndex: 'htv_nohab', sorter: true},
              {title: 'Días mes', dataIndex: 'htv_daymonth', sorter: true},
              {title: 'Creado por', dataIndex: 'created_by', sorter: true},
              {title: 'Creado el', dataIndex: 'created_on', sorter: true},
              {title: 'Modificado por', dataIndex: 'modified_by', sorter: true},
              {title: 'Modificado el', dataIndex: 'modified_on', sorter: true}
            ]
          }
        },
        endpointExcel: 'dist_vac_consulta_/downloadExcel',
        fileNameExcel: 'DisfruteDeVacaciones',
        paramsT: {}
      }
    },
    methods: {
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns}
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Consultas/DistVacConsultas.vue